import React, { useState } from "react"

import ArrowRight from "@svg/ui/arrow-right-skinny.svg"
import PropTypes from "prop-types"
import { CSSTransition } from "react-transition-group"

export const SubmitSolid = ({ label, formSubmitted, disabled, className = "" }) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <button
      type="submit"
      disabled={disabled}
      className={`${className} text-16 border transition-colors duration-300 hover:bg-transparent hover:text-black hover:border-black flex items-center py-4 px-6 font-semi`}
      style={{ borderRadius: "30px" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="flex items-center gap-4">
        <span>{formSubmitted ? "Thank you!" : label}</span>

        <CSSTransition in={isHovered} timeout={300} classNames="button-arrow">
          <div className="flex items-center fill-current">
            <ArrowRight />
          </div>
        </CSSTransition>
      </div>
    </button>
  )
}

SubmitSolid.propTypes = {
  label: PropTypes.string.isRequired,
  formSubmitted: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}
